export default "__VITE_ASSET__DWQPsBmS__"